<svg
  width="24"
  height="20"
  viewBox="0 0 24 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  *ngIf="isFilled === true"
>
  <rect
    x="1"
    y="1"
    width="22"
    height="18"
    rx="4"
    stroke="currentColor"
    stroke-width="2"
  />
  <rect x="1" y="12" width="22" height="7" rx="2" fill="currentColor" />
</svg>

<svg
  width="24"
  height="20"
  viewBox="0 0 24 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  *ngIf="isFilled === false"
>
  <rect
    x="1"
    y="1"
    width="22"
    height="18"
    rx="4"
    stroke="currentColor"
    stroke-width="2"
  />
  <line x1="0" y1="12" x2="24" y2="12" stroke="currentColor" stroke-width="2" />
</svg>
